import { Logger } from '@sdflc/utils';
import { appSettings } from '../config/appSettings';

const logger = new Logger({
  level: appSettings.logLevel,
});

export { logger };
